import _ from 'underscore';
import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import { useShowEntityBottomBar } from 'hooks/useShowEntityBottomBar';
import {
	BreadcrumbsPropType,
	NavigationPropType,
	PromoBlockPropType,
	TagPropType
} from 'propTypes/common';
import { PublicationType } from 'propTypes/entities';

import { Layout } from 'components/Layout';
import ArticleMainWrap from 'components/ArticleMainWrap';
import Container from 'components/Container';
import EntityTopBar from 'components/sections/EntityTopBar';
import EntityBottomBar from 'components/sections/EntityBottomBar';
import EntityTags from 'components/sections/EntityTags';
import StyledContent from 'components/StyledContent';
import PublicationTitle from 'components/PublicationTitle';

import PushkinDayPromoBlock from 'components/promoBlocks/PushkinDayPromoBlock';
import ProgressBarWrap from 'components/ProgressBarWrap';
import SectionSimilarEntities from './components/SectionSimilarEntities';

const NewsTemplate = ({
	breadcrumbs,
	entityMeta,
	publication,
	topPromoBlock,
	similarMaterials,
	menu,
	tags,
	pushkinDayPromoBlock
}) => {
	const { jsonText, title } = publication;
	const mainContentRef = useRef(null);
	const progressBarContentRef = useRef(null);
	const showEntityBottomBar = useShowEntityBottomBar(mainContentRef);

	return (
		<Layout
			entityType="publications"
			meta={entityMeta}
			entity={publication}
			{...{ menu, topPromoBlock, progressBarContentRef }}
		>
			<EntityTopBar
				breadcrumbs={breadcrumbs}
				entity={publication}
				entityType="publications"
			/>

			<ArticleMainWrap>
				<>
					<ProgressBarWrap ref={progressBarContentRef}>
						<Container width="entity">
							<PublicationTitle title={title} />
						</Container>

						<div ref={mainContentRef}>
							<Container width="entityStyledContent">
								<StyledContent blocks={jsonText} />
							</Container>
						</div>
					</ProgressBarWrap>

					{showEntityBottomBar && (
						<EntityBottomBar entity={publication} entityType="publications" />
					)}

					{!_(tags).isEmpty() && <EntityTags tags={tags} />}
				</>
			</ArticleMainWrap>

			{!_.isEmpty(pushkinDayPromoBlock) && (
				<Container width="entity">
					<PushkinDayPromoBlock
						promoBlock={pushkinDayPromoBlock}
						spacing="entity"
					/>
				</Container>
			)}

			{!_(similarMaterials).isEmpty() && (
				<SectionSimilarEntities entities={similarMaterials} />
			)}
		</Layout>
	);
};

NewsTemplate.propTypes = {
	breadcrumbs: BreadcrumbsPropType.isRequired,
	entityMeta: PropTypes.object.isRequired,
	similarMaterials: PropTypes.arrayOf(PublicationType),
	menu: NavigationPropType.isRequired,
	publication: PublicationType,
	tags: PropTypes.arrayOf(TagPropType).isRequired,
	topPromoBlock: PromoBlockPropType,
	pushkinDayPromoBlock: PromoBlockPropType
};

export default NewsTemplate;
